import { RETRO_STATUS_OPTIONS } from '../../constants';

export default function RetroColumnPicker({ value, onChange, getButtonClass }) {
  return RETRO_STATUS_OPTIONS.map((opt) => (
    <button
      key={opt.value}
      type="button"
      className={getButtonClass(opt.value, opt.value === value)}
      onClick={() => onChange(opt.value)}
    >
      {opt.label}
    </button>
  ));
}
